const USERNAME_PATTERN = /^[a-zA-Z0-9._-]{3,32}$/;

/** Matches backend sanitizeLocalPart() in mof-strapi auth/plane/username.ts */
function sanitizeUsernameBase(raw: string): string {
  let base = String(raw || "user")
    .toLowerCase()
    .replace(/[^a-z0-9._-]/g, "")
    .replace(/^\.+|\.+$/g, "");
  if (base.length < 3) base = `user${base}`;
  if (base.length > 32) base = base.slice(0, 32);
  return base;
}

/** Derive a username suggestion from a display name (first.last, sanitized). */
export function generateUsernameFromName(name: string): string {
  const trimmed = name.trim();
  if (!trimmed) return "";

  const parts = trimmed
    .split(/\s+/)
    .map((part) =>
      part
        .toLowerCase()
        .replace(/[^a-z0-9._-]/g, "")
        .replace(/^\.+|\.+$/g, ""),
    )
    .filter(Boolean);

  const joined = parts.join(".");
  const base = sanitizeUsernameBase(joined || trimmed);
  return USERNAME_PATTERN.test(base) ? base : "";
}
